import { render, staticRenderFns } from "./IconQuestionMark.vue?vue&type=template&id=2a64fa9f&"
import script from "./IconQuestionMark.vue?vue&type=script&lang=js&"
export * from "./IconQuestionMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports